import React from "react"
import { Link } from "react-router-dom"

import "../Table.sass"

import { formatDate } from "../../utils/format-date.js"

const UsersTable = ({
  data,
  selectedIds,
  onToggleUser,
  onToggleAll,
}) => {
  if (data.length === 0)
    return (
      <span className="font text-2 error-box">
        {" "}
        No records fetched{" "}
      </span>
    )

  const allSelected =
    data.length > 0 && data.every((item) => selectedIds.includes(item.id))

  return (
    <>
      <table>
        <thead>
          <tr>
            <th className="user-select-cell">
              <input
                type="checkbox"
                checked={allSelected}
                onChange={onToggleAll}
                aria-label="Selecionar todos"
              />
            </th>
            <th>Nome</th>
            <th>Email</th>
            <th>Status</th>
            <th>Grupo(s)</th>
            <th>ID contrato</th>
            <th>Nome contrato</th>
            <th>Data criação</th>
            <th>Data atualização</th>
            <th>ID</th>
          </tr>
        </thead>
        <tbody>
          {data.map((item) => (
            <tr key={item.id}>
              <td className="user-select-cell">
                <input
                  type="checkbox"
                  checked={selectedIds.includes(item.id)}
                  onChange={() => onToggleUser(item.id)}
                  aria-label={`Selecionar ${item.name}`}
                />
              </td>
              <td>
                <Link to={"/admin/user/" + item.id}>{item.name}</Link>
              </td>
              <td>{item.email}</td>
              <td>{item.isActive !== false ? "Ativo" : "Inativo"}</td>
              <td>{item.isAdmin === true ? "admin" : ""}</td>
              <td>{item.contract.id}</td>
              <td>{item.contract.name}</td>
              <td>{formatDate(item.createdOn)}</td>
              <td>{formatDate(item.updatedOn)}</td>
              <td>{item.id}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default UsersTable
